"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Role = void 0;
const Role = {
  NO_ROLE: 0,
  CUSTOMER: 1,
  ADMIN: 2,
  SUPER: 4,
  ATENDENTE: 8,
  INTERNAL: 16,
  MASTER: 32
};
exports.Role = Role;

class Group {
  static isAllowed($require, $have) {
    return $have == Role.INTERNAL || $require == Role.NO_ROLE || $require & $have;
  }

  static getPermissions($data) {
    return $data.reduce(($carry, $role) => {
      return $carry | $role;
    }, 0);
  }

}

exports.default = Group;